import { isOpaqueStoredMethodType, storedMethodTypeLabel } from '@neon-one/auctions-types';
import type { OutstandingOffer, SettlementBidderSummary, StoredCard } from '@neon-one/auctions-types';
import { InvoiceStatus } from './payment-status';
import type { BidderRollup } from './bidder-rollup';

function storedLabel(method: StoredCard | null | undefined): string | null {
  if (!method) return null;
  const rail = storedMethodTypeLabel(method.methodType);
  if (isOpaqueStoredMethodType(method.methodType)) return rail;
  const name = method.brand || rail;
  return method.last4 ? `${name} ···· ${method.last4}` : name;
}

// §2.5 — An unanswered offer is bidder work even before an invoice exists.
function offereeRow(bidder: SettlementBidderSummary): BidderRollup {
  return {
    bidderUuid: bidder.bidderUuid, bidderName: bidder.bidderName, bidderEmail: bidder.bidderEmail ?? '',
    invoices: [], openInvoice: null, drawerInvoice: null, itemCount: 0,
    dueCents: 0, paidCents: 0, refundedCents: 0, pendingRefundCents: 0,
    status: InvoiceStatus.NothingDue, paymentMethodLabel: storedLabel(bidder.storedPaymentMethod),
    hasPendingOffer: true, hasCardOnFile: bidder.storedPaymentMethod != null, chargeable: false,
  };
}

export function includeUninvoicedOfferees(
  rows: readonly BidderRollup[],
  bidders: readonly SettlementBidderSummary[],
  offers: readonly OutstandingOffer[],
): BidderRollup[] {
  const byBidder = new Map(rows.map(row => [row.bidderUuid, row]));
  const targets = new Set(offers.map(offer => offer.bidderUuid));
  for (const bidder of bidders) {
    if (!byBidder.has(bidder.bidderUuid) && (bidder.hasOutstandingOffer || targets.has(bidder.bidderUuid))) {
      byBidder.set(bidder.bidderUuid, offereeRow(bidder));
    }
  }
  return [...byBidder.values()].sort((a, b) => b.dueCents - a.dueCents || a.bidderName.localeCompare(b.bidderName));
}
